
/*
    The page shell for displaying trips, mostly for the sake of starters

    It handles loading the data, toggling the filter, trip multi-select & operations,
    and updating the list when trips are added/updated/cancelled/hidden,
*/

import React from "react";

import SubNav from "../Components/SubNav";
import BusOpsFilter from "../Filters/BusOpsFilter";

import MainContext from "../MainContext";

import Constants from "../Constants";

import VerticalLayout from "../Components/VerticalLayout";
import SingleOpenList from "../Components/SingleOpenList";

import * as BusOpsRequests from "../Requests/BusOpsRequests";
import BusOpsData from "../DataDisplay/BusOpsData";

import { getRoutes, getLanes } from "../Requests/UtilityRequests";

import { replaceElement, deleteElement, getTimeStringFromDate, getCurrentDateWithMinutesAdded } from "../Scripts/Utilities";

import TripSwitchForm from "../Forms/TripSwitchForm";
import BusPullForm from "../Forms/BusPullForm";

import UnusedBuses from "../DataDisplay/UnusedBuses";
import UnfilledTrips from "../DataDisplay/UnfilledTrips";

import { runReassignment, checkForReassignmentChange, cancelUnfilledTrip, noShowUnusedBus } from "../Requests/ReassignmentRequests";

import BaseValues from "../Requests/BaseValues";

//
//
//
function addToUnfilledLookup(toTrip, fromTrip) {

    const key = toTrip.TripNumber + toTrip.SchedDepTime;
    const value = fromTrip.Run;
    const lookupString = localStorage.getItem("__UNFILLED_LOOKUP__");

    let lookup = {};

    if(lookupString){
        lookup = JSON.parse(lookupString);
    }

    lookup[key] = value;
    const serialized = JSON.stringify(lookup);
    localStorage.setItem("__UNFILLED_LOOKUP__", serialized);
}
//
//
//

let switchFunction = {
    f: () => {}
};

let switchCheckInterval = null;

const reassignmentCheckPeriod = 5000;

const REMOVED_LOCALSTORAGE_KEY = "__REMOVED_LOCALSTORAGE__";

export default class BusOpsPage extends React.Component {

    static contextType = MainContext;

    state = {
        filterValues: null,
        trips:[],
        unfilledTrips: [],
        unusedBuses: [],
        selectedTrips: [],
        message: "",
        scrollOn: true,
        closeAll: false,
        showTripSwitch: false,
        showPullForm: false,
        switchUnused: false,
        switchIndex: 0,
        switchedLeftHanging: [],
        pullTrip: null,
        // switchCheckInterval: null
    };

    //
    // Lifecycle methods
    //
    componentDidMount(){

        if(this.context.setClearSwitchCheckInterval){
            this.context.setClearSwitchCheckInterval(this.clearSwitchCheckInterval);
        }

        // check the user for whether they have a location set
        // if not, then need to show the filter
        if(!this.context.user.currentLocation && !this.context.filterValues){
            this.context.toggleFilter(null, true);
            // and then set the filter value with the current location/lane info
            // and get the data
        }
        else if(this.context.filterValues){

            // do I override the time here if it's departed mode?

            const filterValues = {...this.context.filterValues};

            if(this.props.mode === "REASSIGNED") {
                filterValues.start = this.getDayStartTime();
                filterValues.end = this.getDayEndTime();
            }

            this.setState({filterValues}, () => {
                this.getData();
            });
        }
        else if(this.context.user.currentLocation){
            const user = this.context.user;

            // pre-fill the timespan
            let lookBehind = (this.props.mode === "DEPARTED") ? 60 : 30;
            lookBehind = user.lookbehind ? 1 * user.lookbehind : lookBehind;
            let lookAhead = user.lookahead ? 1 * user.lookahead : 60;

            if(user && user.access !== Constants.access.starter){
                console.log("LOOKAHEAD CHANGED TO ZERO");
                lookAhead = 0;
                lookBehind = 0;
            }
            else{
                console.log("NO LOOKAHEAD OVERWRITE", user, user.access);
            }

            let start = getCurrentDateWithMinutesAdded(-1 * ((lookBehind === 0) ? 30 : lookBehind));
            let end = getCurrentDateWithMinutesAdded((lookAhead === 0) ? 60 : lookAhead);

            if(this.props.mode === "REASSIGNED") {
                start = this.getDayStartTime();
                end = this.getDayEndTime();
            }

            const filterValues = {
                startDate: start,
                endDate: end,
                startHour: 10,
                startTime: getTimeStringFromDate(start),
                endTime: getTimeStringFromDate(end),
                location: this.context.user.currentLocation.location_id,
                locationError: false,
                routes: [],
                routesSelected: [],
                lanes: [],
                lanesSelected: this.context.user.currentLocation.assigned_lane_gate || [],
                lookAhead,
                lookBehind
            };

            if(this.props.mode === "departed") {
                this.setDepartedFullDay(filterValues);   
            }

            console.log("premade filter values", filterValues);

            this.fillRoutes(this.context.user.currentLocation.location_id);
            this.fillLanes(this.context.user.currentLocation.location_id);

            this.setState({filterValues}, () => {
                console.log("AUTO LOAD", this.state.filterValues);
                this.getData();
            });
        }
    }

    // 
    // check if we're supposed to reload the data
    //
    componentDidUpdate() {
        if(this.props.dataReload){
            console.log("STARTER RELOAD");
            this.props.setReload(false, () => {                
                this.getData();
            });
        }
    }

    componentWillUnmount() {
        console.log("UNMOUNT BUSOPS PAGE");
        console.log("UNMOUNT BUSOPS PAGE");
        console.log("UNMOUNT BUSOPS PAGE");
        console.log("UNMOUNT BUSOPS PAGE");
        console.log("UNMOUNT BUSOPS PAGE");
        console.log("UNMOUNT BUSOPS PAGE");
        if(this.props.showExternalChange){
            this.props.showExternalChange(false);
        }
        this.clearSwitchCheckInterval();
    }

    getDayStartTime = () => {
        const date = new Date();
        date.setHours(0,0,0);
        return date;
    }

    getDayEndTime = () => {
        const date = new Date();
        date.setHours(23, 59, 59);
        return date; 
    }

    openTripSwitch = (evt, index, func, isUnused = false) => {
        evt.stopPropagation();

        console.log("OPEN TRIP SWITCH", index, func, isUnused);

        switchFunction.f = func;

        this.setState(
            {
                showTripSwitch: true,
                switchIndex: index,
                switchUnused: isUnused
            }
        );
    }

    //
    // from is the bus
    // to is the trip
    //
    switchTrips = (toIndex, fromIndex, toUnfilled = false, fromUnused = false) => {
        console.log("SWITCH TRIP", switchFunction, fromIndex, toIndex, toUnfilled, fromUnused);

        const pulled = this.state.pullTrip;

        let toTrip = toUnfilled ? this.state.unfilledTrips[toIndex] : this.state.trips[toIndex];
        toTrip = {...toTrip};

        let fromTrip = pulled ? pulled : (fromUnused ? this.state.unusedBuses[fromIndex].ref : this.state.trips[fromIndex]);
        fromTrip = {...fromTrip};

        console.log("TO TRIP", toTrip);
        console.log("FROM TRIP", fromTrip);

        // special cases
        if(toUnfilled){
            console.log("UNFILLED IS TARGET", toTrip);
            toTrip.Run = toTrip.run_id_original;
            toTrip.vehicle_id = toTrip.vehicle_id_original;

            addToUnfilledLookup(toTrip, fromTrip);
        }

        if(fromUnused){
            fromTrip.Run = fromTrip.run_id_original;
            fromTrip.vehicle_id = fromTrip.vehicle_id_original;
        }

        // call to API
        const request = () => runReassignment(toTrip, fromTrip);

        const then = ({data}) => {

            // alert("REASSIGNMENT HAS BEEN RUN");

            console.log("REASSIGNMENT RETURN", data);

            // then reload
            this.getData();
        }

        this.context.runProcessing(request, then, "run_reassignment");
    }

    markUnusedNoShow = (index, reason) => {
        const bus = this.state.unusedBuses[index]

        // call to API
        const request = () => noShowUnusedBus(bus, reason);

        const then = ({data}) => {

            //alert("NO SHOW UNUSED RUN");

            // then reload
            this.getData();
        }

        this.context.runProcessing(request, then, "run_reassignment");
    }

    markUnfilledCancelled = (index, reason) => {
        const trip = this.state.unfilledTrips[index];

        // call to API
        const request = () => cancelUnfilledTrip(trip, reason);

        const then = ({data}) => {

            //alert("CANCEL UNFILLED RUN");

            // then reload
            this.getData();
        }

        this.context.runProcessing(request, then, "run_reassignment");
    }

    tripMatch = (trip1, trip2) => {
        return trip1.vehicle_id === trip2.vehicle_id 
            && trip1.TripNumber === trip2.TripNumber 
            && trip1.SchedDepTime === trip2.SchedDepTime;
    }

    getData = (callback) => {    
        // function to actually get the data    
        const func = () => {
            // clear the switch check interval to avoid any race conditions
            this.clearSwitchCheckInterval();

            // the mode could be arrivals, departed, or all
            const request = () => BusOpsRequests.getTrips(this.state.filterValues, this.props.mode);
    
            const then = ({data}) => {
                if(data.length){
                    console.log("RAW TRIPS DATA", data);
                    const {trips, unusedBuses, unfilledTrips} = this.splitTrips(data);

                    this.setState({trips, unusedBuses, unfilledTrips, message: ""}, () => {
                        console.log("TRIPS DATA", this.state.trips);
                        if(callback && typeof callback === "function"){
                            callback();
                        }
                    });
                }
                else {
                    this.setState({trips: [], message: "No Records Found"});
                    this.context.sendNotification(true, "No records found for this filter");
                }

                // at the end, be sure to get the user's new location/lane listing
                this.context.updateUserDetails();

                console.log("START CHECK INTERVAL");

                // start the switch check interval
                this.startSwitchCheckInterval();
            };

            this.context.runProcessing(request, then, "getTrips");
        };

        //
        // if the user is a starter, need to pre-fill the filter values for the time span
        // before executing the above method
        //
        if(this.context.user.access === Constants.access.starter){

            // this can only be activated if the user is a starter

            const filterValues = {...this.state.filterValues};

            const start = getCurrentDateWithMinutesAdded(-1* filterValues.lookBehind);
            const end = getCurrentDateWithMinutesAdded(filterValues.lookAhead);

            console.log({start, end});

            filterValues.start = start;
            filterValues.startTime = getTimeStringFromDate(start);
            filterValues.end = end;
            filterValues.endTime = getTimeStringFromDate(end);

            console.log("FILTER VALUES", this.state.filterValues, filterValues);

            this.setState({filterValues}, () => {
                func();
            });
        }
        else{
            func();
        }
    }

    //
    // break off the unusedBuses and UnfilledTrips
    //
    splitTrips = (data) => {
        let trips = [];
        let unusedBuses = [];
        let unfilledTrips = [];

        const tripsAll = [];
        const unusedAll = [];
        const unfilledAll = [];

        // if it's departed mode, don't show any partial records
        const departed = this.props.mode === "DEPARTED";
        const all = this.props.mode === "ALL";
        const reassigned = this.props.mode === "REASSIGNED";
        const active = this.props.mode === "NOT-DEPARTED";

        // just get a sample for now for the sake of display
        // unusedBuses.push(data[0]);
        // unfilledTrips.push(data[1]);

        // OK, I think maybe I should just put everything into the buckets first
        // and then filter those afterwards...

        this.clearOldRemoveFilter();

        let tripsFilterList = window.localStorage.getItem(REMOVED_LOCALSTORAGE_KEY);

        if(tripsFilterList){
            tripsFilterList = JSON.parse(tripsFilterList);
        }

        data.forEach(trip => {

            if(tripsFilterList){
                const id = trip.SchedDepTime + "_" + trip.TripNumber + "_" + trip.TimePoint;
                let found = false;
                tripsFilterList.forEach(t => {
                    console.log("FILTER MATCH OR NOT?", id, t.id, (t.id === id));
                    found |= (t.id === id);
                });

                if(found){
                    // move on to the next record
                    return;
                }
            }

            // const delayed = !!trip.DelayReason;

            // if(departed && !trip.actual_departure_time && !delayed){
            //     // return;
            // }

            // let isUnfilled = false;

            // console.log("CHECK FOR DELAY", (!trip.DelayReason || all), trip.DelayReason, all);

            // if(
            //     this.isUnused(trip) ||
            //     (!departed && this.isUnused(trip) && (!delayed || all || reassigned))
            //     // || (departed && delayed)
            // ){
            //     const busCopy = {...trip};
            //     busCopy.ref = trip;
            //     unusedBuses.push(busCopy);
            // }
            // else if(
            //     this.isUnfilled(trip) ||
            //     (!departed && this.isUnfilled(trip) && (!delayed || all || reassigned))
            //     // || (departed && delayed)
            // ){
            //     unfilledTrips.push(trip);
            //     isUnfilled = true;
            // }

            // if(active && trip.actual_departure_time){
            //     // return;
            // }

            // if(!isUnfilled /*&& !(active && delayed)*/){
            //     trips.push(trip);
            //     // need to check if this is a "merged" record
            //     // and if so, set trip.switched.tripFrom

            //     this.checkTripFrom(trip);
            // }

            let isUnfilled = false;

            if(
                this.isUnused(trip)
            ){
                const busCopy = {...trip};
                busCopy.ref = trip;
                unusedAll.push(busCopy);
            }
            else if(
                this.isUnfilled(trip)
            ){
                unfilledAll.push(trip);
                isUnfilled = true;
            }

            if(!isUnfilled /*&& !(active && delayed)*/){
                tripsAll.push(trip);
                // need to check if this is a "merged" record
                // and if so, set trip.switched.tripFrom

                this.checkTripFrom(trip);
            }
        });

        // figure out which records to remove

        if(active) {
            // no departed trips
            // no trips or partials with delay

            tripsAll.forEach(t => {
                if(!t.actual_departure_time && (!t.DelayReason || t.switched)) {
                    trips.push(t);
                }
            });

            unusedAll.forEach(t => {
                if(!t.DelayReason) {
                    unusedBuses.push(t);
                }
            });

            unfilledAll.forEach(t => {
                if(!t.DelayReason) {
                    unfilledTrips.push(t);
                }
            });
        }
        else if(departed) {
            // no undeparted trips or partials unless they have delay         

            tripsAll.forEach(t => {
                if(t.actual_departure_time || (t.DelayReason && !t.switched)){
                    trips.push(t);
                }
            });

            unusedAll.forEach(t => {
                if(t.DelayReason) {
                    unusedBuses.push(t);
                }
            });

            unfilledAll.forEach(t => {
                if(t.DelayReason) {
                    unfilledTrips.push(t);
                }
            });
        }
        else if(reassigned) {
            // all partials, all reassigned records

            tripsAll.forEach(t => {
                if(t.switched) {
                    trips.push(t);
                }
            });

            unusedBuses = unusedAll;
            unfilledTrips = unfilledAll;
        }
        else if(all) {
            trips = tripsAll;
            unusedBuses = unusedAll;
            unfilledTrips = unfilledAll;
        }

        return {trips, unusedBuses, unfilledTrips};
    }

    isUnused(trip) {
        return trip.driver_replaced === "TRUE" && trip.driver_reassigned === "";
    }

    isUnfilled(trip) {
        return trip.driver_replaced === "" && trip.driver_reassigned === "TRUE";
    }

    checkTripFrom(trip){
        console.log("CHECK TRIP FROM", trip.driver_replaced, trip.route_original, trip);
        if(trip.driver_replaced === "TRUE") {
            trip.switched = {
                tripFrom: {
                    departure: trip.sched_dep_time_original,
                    route: trip.route_original,
                    run: trip.run_id_new
                }
            };
        }
    }

    openPullForm = () =>{
        this.setState({showPullForm: true, pullTrip: null});
    }

    clearSwitchCheckInterval() {
        if(switchCheckInterval) {
            clearInterval(switchCheckInterval);
        }
    }

    startSwitchCheckInterval() {

        // if no lanes selected for some reason, don't run this check?
        if(!this.state.filterValues
            || !this.state.filterValues.lanesSelected 
            || this.state.filterValues.lanesSelected.count === 0) {
                console.log("CHECK EARLY RETURN", this.context);
            return;
        }

        console.log("SWITCH INTERVAL");

        // the lanes selected value should always have something for PABT, right?
        // would I put "ALL" otherwise?
        const params = {
            location: this.context.user.currentLocation.location_id,
            gates: this.state.filterValues.lanesSelected.join(",")
        };

        let lastTimeChecked = new Date();

        // store the interval so that it can be cleared later
        switchCheckInterval = setInterval(() => {

            console.log("CHECK BEGIN", lastTimeChecked);
            // return;

            checkForReassignmentChange(params)
            .then(({data}) => {

                console.log("DO WE HAVE A LAST CHANGE?", data, "__", lastTimeChecked);

                if(data && data.timestamp){

                    
                    const changed = new Date(data.timestamp);
                    console.log("LAST CHANGE TIME", changed, "__", lastTimeChecked);

                    if(changed.getTime() > lastTimeChecked.getTime()){
                        lastTimeChecked = changed;

                        // show an indicatior on screen that there's been a change
                        // and prompting the user to reload the data
                        // should be coming from the DataContext
                        this.props.showExternalChange(true);

                        // no need to keep checking
                        clearInterval(switchCheckInterval);
                    }
                }
            })
            .catch(err => {
                // if we have no token, then stop the checks from recurring
                if(!BaseValues.APIKey || !BaseValues.length || BaseValues.APIKey.trim().length === 0) {
                    clearInterval(switchCheckInterval);
                }
                console.error("CHECK FOR REASSIGNMENT CHANGE ERROR", err);
            });
        }, reassignmentCheckPeriod);

        // this.setState({switchCheckInterval});
    }

    //
    // fill in the filter route options based on the current location
    //
    fillRoutes = (location) => {
        const request = () => getRoutes(location);
        const then = ({data}) => {
            const cleaned = data.map(v => v.Route);
            this.setState({filterValues: {...this.state.filterValues, routes: cleaned}});
        };
        this.context.runProcessing(request, then, "getRoutes");
    }

    //
    // fill in the filter lane options based on the current location
    //
    fillLanes = (location) => {
        const request = () => getLanes({location/*, route: this.state.routesSelected*/});
        const then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            this.setState({filterValues: {...this.state.filterValues, lanes: cleaned}});
        };
        this.context.runProcessing(request, then, "getLanes");
    }

    //
    //
    applyFilter = (values) => {
        console.log("apply filter", values);
        this.setState({filterValues: values, trips: []}, () => {
            this.getData(() => {
                this.context.toggleFilter(null, false);
            });
            this.context.updateFilter(values);
        });
    }

    //
    // mark the record at the given index as being "selected" or not,
    // for the sake of mass operation
    //
    onSelect = (index) => {
        // toggle the selection
        let selected = [];

        if(this.state.selectedTrips.includes(index)){
            selected = this.state.selectedTrips.filter((v) => v !== index);
        }
        else{
            selected = [...this.state.selectedTrips, index].sort();
        }

        this.setState({selectedTrips: selected});
        this.context.toggleFilter(null, false);
    }

    //
    //
    deselectAll = () => {
        this.setState({selectedTrips: []});
    }

    //
    // the API request was already handled by this point,
    // so just refresh the data to be sure we show it
    //
    addTrip = (newTrip) =>{
        // just reload for now
        this.applyFilter(this.state.filterValues);
    }

    //
    //
    updateTrip = (newTrip, index) => {

        this.checkTripFrom(newTrip);

        this.setState({
            trips: replaceElement(this.state.trips, newTrip, index)
        });
    }

    //
    //
    removeTrip = (index, filterInTheFuture) => {

        const removedTrip = this.state.trips[index];

        this.setState({
            trips: deleteElement(this.state.trips, index),
            closeAll: true
        }, () => {
            // flicker the closeAll
            this.setState({closeAll: false});
        });

        console.log("REMOVED TRIP", removedTrip);

        if(filterInTheFuture){

            console.log("REMOVE IN THE FUTURE");

            this.clearOldRemoveFilter();

            const today = new Date();
            const todayDateString = today.getDate() + "_" + today.getMonth() + "_" + today.getYear();

            let tripFilter = window.localStorage.getItem(REMOVED_LOCALSTORAGE_KEY);

            console.log("REMOVE WITH TRIP FILTER", tripFilter);

            if(!tripFilter) {
                tripFilter = [];
            }

            console.log("REMOVE FILTER?", tripFilter);

            // how to identify the record?
            // be sure to add a timestamp
            const trip = {
                id: removedTrip.SchedDepTime + "_" + removedTrip.TripNumber + "_" + removedTrip.TimePoint,
                timestamp: todayDateString
            };

            tripFilter.push(trip);

            const tripFilterJSON = JSON.stringify(tripFilter);
            window.localStorage.setItem(REMOVED_LOCALSTORAGE_KEY, tripFilterJSON);
        }
    }

    //
    //
    clearOldRemoveFilter = () => {
        const today = new Date();
        const todayDateString = today.getDate() + "_" + today.getMonth() + "_" + today.getYear();

        let tripFilter = window.localStorage.getItem(REMOVED_LOCALSTORAGE_KEY);

        let changed = false;

        if(tripFilter){
            tripFilter = JSON.parse(tripFilter);
            // remove any elements not from today
            // this will make the check very easy
            const replace = [];

            tripFilter.forEach(t => {
                if(t.timestamp === todayDateString){
                    changed = true;
                    replace.push(t);
                }
            });

            tripFilter = replace;
        }

        if(changed){
            const tripFilterJSON = JSON.stringify(tripFilter);
            window.localStorage.setItem(REMOVED_LOCALSTORAGE_KEY, tripFilterJSON);
        }
    }

    //
    // mass operation: cancel all selected trips
    //
    cancelAll = () => {
        const run = window.confirm("Are you sure you want to mark all of these trips as lost?");
        if(run){
            const request = () => {
                console.log("run all cancel requests");
                return Promise.allSettled(this.state.selectedTrips.map((index) => {
                    // hmm, what do I pass into here
                    return BusOpsRequests.cancelTrip(this.state.trips[index]);
                }));
            };
    
            const then = (values) => {

                // remove those trips from the list being displayed

                console.log("CANCEL REQUEST RETURN VALUES", values);
    
                const remainingSelected = [];
                const tripCopy = [...this.state.trips];
    
                // go from front to back, to make the splicing work more easily
                for(let i = values.length-1; i >= 0; i--){
                    const hasError = values[i].status === "rejected";
    
                    if(hasError){
                        const index = this.state.selectedTrips[i];
                        remainingSelected.push(index);
                    }
                    else{
                        const index = this.state.selectedTrips[i];
                        tripCopy.splice(index, 1);
                    }
                }
    
                if(remainingSelected.length > 0){
                    // put it back in the right order
                    remainingSelected.sort();
                    this.context.sendNotification(true, "Not all trips successfully cancelled");
                }
                else{
                    this.context.sendNotification(false, "Trips successfully cancelled");
                }
    
                this.setState({trips: tripCopy, selectedTrips: remainingSelected});
            };
    
            this.context.runProcessing(request, then, "cancelTrip");
        }
    }

    //
    // mass operation: hide all trip records that are marked as selected
    //
    hideAll = () => {
        const run = window.confirm("Are you sure you want to hide all of these trips?");
        if(run){
            const request = () => {
                console.log("run all hide requests");
                return Promise.allSettled(this.state.selectedTrips.map((index) => {
                    // hmm, what do I pass into here
                    return BusOpsRequests.hideTrip(this.state.trips[index]);
                }));
            };

            const then = (values) => {

                // remove those trips from the list being displayed
    
                console.log("HIDE REQUEST RETURN VALUES", values);
    
                const remainingSelected = [];
                const tripCopy = [...this.state.trips];
    
                // go from front to back, to make the splicing work more easily
                for(let i = values.length-1; i >= 0; i--){
                    const hasError = values[i].status === "rejected";
    
                    if(hasError){
                        const index = this.state.selectedTrips[i];
                        remainingSelected.push(index);
                    }
                    else{
                        const index = this.state.selectedTrips[i];
                        tripCopy.splice(index, 1);
                    }
                }

                if(remainingSelected.length > 0){
                    // put it back in the right order
                    remainingSelected.sort();
                    this.context.sendNotification(true, "Not all trips successfully hidden");
                }
                else{
                    this.context.sendNotification(false, "Trips successfully hidden");
                }
    
                this.setState({trips: tripCopy, selectedTrips: remainingSelected});
            };
    
            this.context.runProcessing(request, then, "hideTrip");
        }
    }

    /*
    disableScroll = () => {
        this.setState({scrollOn: false});
    }

    enableScroll = () => {
        this.setState({scrollOn: true});
    }
    */

    //
    //
    //
    //
    //
    render(){

        //
        // set some variables from state to make referencing them look cleaner in the code
        //

        let hasLocation = this.state.filterValues && this.state.filterValues.location;

        const contentClass = this.state.scrollOn ? "content" : "content-noscroll";

        let trips = this.state.trips && this.state.trips.filter(trip => !trip.isSplit);
        const unfilledTrips = this.state.unfilledTrips;
        const unusedBuses = this.state.unusedBuses;

        let firstLanes = this.state.filterValues?.lanesSelected;
        let hasRemainingLanes = false;

        // we only show up to 7 lanes in the subnav at once
        if(this.state.filterValues?.lanesSelected.length > 7){
            firstLanes = this.state.filterValues.lanesSelected.slice(0, 7);
            hasRemainingLanes = true;
        }

        return (
            <div className={(this.props.isDisconnected || this.props.isServerError) ? "no-interaction" : ""}>
            <VerticalLayout firstHeight={hasLocation ? 8 : 0}>
                {
                    this.props.isDisconnected || this.props.isServerError
                    ? <div className="connection-error">
                        {
                            this.props.isDisconnected
                            ? <>NO NETWORK CONNECTION, PLEASE STAND BY</>
                            : null
                        }
                        {
                            this.props.isServerError
                            ? <>SERVER ERROR, PLEASE STAND BY</>
                            : null
                        }
                    </div>
                    : null
                }
                {
                    hasLocation
                    ? (
                        <SubNav>
                        {
                            // if we have trips selected, show the mass operation buttons
                            this.state.selectedTrips.length > 0
                            ? <>
                            <div className="dangerButton" onClick={this.cancelAll}>All Lost</div>
                            <div className="dangerButton" onClick={this.hideAll}>Hide All</div>
                            <div className="dangerButton" onClick={this.deselectAll}>Deselect All</div>
                            </>
                            : 
                            <>
                            {
                                this.context.user && this.context.user.groupid === "BUS"
                                ? <button className="option pull-button" 
                                    style={{marginRight: "auto", zIndex: "100", /*height: "80%",*/ display: "flex", alignItems: "center"}} onClick={this.openPullForm}
                                >
                                    Pull Bus
                                    &nbsp;
                                    <i className="fas fa-random"></i>
                                </button>
                                : ""
                            }
                            { // otherwise show the user's location/lanes
                                this.state.filterValues
                                && this.state.filterValues.location
                                ? ( 
                                    <>
                                    <div><b>LOCATION:</b></div> 
                                    <div className="repeat">{this.state.filterValues.location}</div>
                                    {
                                        this.state.filterValues.lanesSelected.length > 0
                                        ? <>
                                            <div><b>LANES:</b></div>
                                            {
                                                firstLanes.map((lane, index) => {
                                                    return <div key={index} className="repeat">{lane}</div>
                                                })
                                            }
                                            {
                                                    hasRemainingLanes
                                                    ? <div>...</div>
                                                    : null
                                            }
                                        </> 
                                        : null
                                    }
                                    </>
                                )
                                : null
                            }
                            <div style={{marginLeft: "auto"}}></div>
                            </>
                        }
                        </SubNav>
                    )
                    : null
                }
                <div className={contentClass}>
                    <>
                    {
                        // show the filter or not
                        this.context.hasFilter
                        && this.context.filterOpen
                            ? <BusOpsFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} mode={this.props.mode} />
                            : null
                    }

                    {
                        this.state.message !== ""
                        ? <div className="message">
                            {this.state.message}
                        </div>
                        : null
                    }

                    <UnusedBuses data={unusedBuses} openForm={this.openTripSwitch} switchTrips={this.switchTrips} noShow={this.markUnusedNoShow} />
                    <UnfilledTrips data={unfilledTrips} cancel={this.markUnfilledCancelled} />

                    <SingleOpenList 
                        data={trips} 
                        component={BusOpsData} 
                        forceClose={this.context.filterOpen || this.state.selectedTrips > 0 || this.state.closeAll}
                        callback={() => {
                            this.context.toggleFilter(null, false);
                            this.deselectAll();
                        }}
                        props={{
                            selectedList: this.state.selectedTrips, 
                            onSelect: this.onSelect,
                            updateTrip: this.updateTrip,
                            removeTrip: this.removeTrip,
                            addTrip: this.addTrip,
                            refresh: this.getData,
                            openTripSwitch: this.openTripSwitch,
                            enableScroll: this.enableScroll,
                            disableScroll: this.disableScroll,
                            mode: this.props.mode,
                            keyField: "TripNumber",
                            switchTrips: this.switchTrips,
                            undoSwitch: this.undoSwitch,
                            switchedLeftHanging: this.state.switchedLeftHanging,
                            removeFromList: this.removeTrip
                        }} 
                    />

                    {
                        this.state.showTripSwitch
                        ? <TripSwitchForm closeForm={
                                () => {
                                    console.log("CLOSE THE SWITCH FORM");
                                    this.setState({showTripSwitch: false, pullTrip: null});
                                }
                            }
                            selectedTrip={ // use the pullTrip if we have one
                                this.state.pullTrip
                                ? this.state.pullTrip
                                : (this.state.switchUnused
                                    ? this.state.unusedBuses[this.state.switchIndex]
                                    : this.state.trips[this.state.switchIndex])
                            }
                            isPulled={!!this.state.pullTrip}
                            isUnused={this.state.switchUnused}
                            selectedIndex={this.state.pullTrip ? -1 : this.state.switchIndex}
                            options={this.state.trips}
                            switchTrips={switchFunction}
                            directSwitch={this.switchTrips}
                            unFilled={this.state.unfilledTrips}
                        />
                        : null
                    }

                    {
                        this.state.showPullForm
                        ? <BusPullForm 
                            closeForm={
                                () => {
                                    console.log("CLOSE THE SWITCH FORM");
                                    this.setState({showPullForm: false});
                                }
                            }
                            openTripForm={
                                (pullTrip) => {
                                    console.log("NEW PULL TRIP", pullTrip);
                                    this.setState({showTripSwitch: true, showPullForm: false, pullTrip});
                                }
                            }
                        />
                        : null
                    }

                    </>
                </div>
            </VerticalLayout>
            </div>
        )
    }
}
